module.exports = __webpack_public_path__ + "img/update-log.3b547ba7.png";